export default function navigation(forceScrolled = false) {
    return {
        forceScrolled,
        scrolled: forceScrolled,
        initialized: false,
        mobileMenuOpen: false,
        activeDesktopSubmenu: null as string | null,

        init() {
            this.updateScrolled();

            this.$nextTick(() => {
                this.initialized = true;
            });

            this.$watch('mobileMenuOpen', (value: boolean) => {
                document.body.style.overflow = value ? 'hidden' : '';
            });
        },

        destroy() {
            document.body.style.overflow = '';
        },

        updateScrolled() {
            if (this.forceScrolled) {
                this.scrolled = true;
                return;
            }

            this.scrolled = window.pageYOffset > 10;
        },

        openMobileMenu() {
            this.mobileMenuOpen = true;
        },

        closeMobileMenu() {
            this.mobileMenuOpen = false;
        },

        openDesktopSubmenu(id: string) {
            this.activeDesktopSubmenu = id;
        },

        closeDesktopSubmenu(id: string, element?: HTMLElement) {
            this.$nextTick(() => {
                if (this.activeDesktopSubmenu !== id) {
                    return;
                }

                if (element?.matches(':focus-within')) {
                    return;
                }

                this.activeDesktopSubmenu = null;
            });
        },

        closeDesktopSubmenus() {
            this.activeDesktopSubmenu = null;
        },
    };
}

export function desktopNavigationItem() {
    return {
        arrowLeft: '60px',

        updateSubmenuArrow(element: HTMLElement) {
            this.$nextTick(() => {
                const submenu = element.querySelector<HTMLElement>('.arrow-up');

                if (!submenu) {
                    return;
                }

                const submenuRect = submenu.getBoundingClientRect();
                const itemRect = element.getBoundingClientRect();
                const centerOffset = itemRect.left + itemRect.width / 2 - submenuRect.left;

                this.arrowLeft = `${centerOffset}px`;
            });
        },

        get submenuArrowStyle() {
            return `--arrow-dynamic-left: ${this.arrowLeft}`;
        },
    };
}

export function mobileNavigationItem() {
    return {
        expanded: false,

        toggle() {
            this.expanded = !this.expanded;
        },
    };
}
